<template>
  <div class="sms-overage display">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <p class="title md-headline">SMS overages</p>
      </div>
    </div>
    <div v-if="!localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1">
        <div class="md-layout-item md-small-size-100">
          <p class="md-subheading">
            Please configure Stripe Customer ID to edit SMS overage information.
          </p>
        </div>
      </div>
    </div>
    <div v-if="localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1" v-if="!updatingOverage">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Price per overage SMS</p>
          <span class="md-subheading mb-1" v-if="localEnterprise.owner.stripeSmsOveragePrice">
            {{ localEnterprise.owner.stripeSmsOveragePrice | toCurrency }}
          </span>
          <span class="md-subheading" v-if="!localEnterprise.owner.stripeSmsOveragePrice">
            Not set.
          </span>
        </div>
      </div>
      <form class="md-layout md-gutter" v-if="updatingOverage" @submit.prevent="setPrice">
        <div class="md-layout-item md-small-size-100">
          <md-field name="newPrice">
            <label for="newPrice">
              Price (format: 0.00)
            </label>
            <md-input v-model="overage.newPrice" name="newPrice" />
          </md-field>
        </div>
      </form>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-button class="md-raised" @click="updatingOverage = true" v-if="!updatingOverage">
            Update overage price
          </md-button>
          <md-button class="md-raised md-primary" @click="saveEnterpriseOveragePrice"
            v-if="updatingOverage">
            Save overage price
          </md-button>
          <md-button class="md-raised" @click="updatingOverage = false" v-if="updatingOverage">
            Cancel
          </md-button>
        </div>
      </div>
    </div>
    <snackbar-message-handler :message="snackbarMessage"></snackbar-message-handler>
  </div>
</template>
<script type="ts">
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';

export default {
  components: {
    SnackbarMessageHandler,
  },
  name: 'enterprise-sms-overage',
  props: ['enterprise'],
  methods: {
    saveEnterpriseOveragePrice() {
      let amount = Math.trunc(parseFloat(this.overage.newPrice) * 100);

      if (amount === 0) {
        amount = null;
      }

      this.enterpriseService.updateEnterprise(
        this.enterprise.id,
        {
          owner: {
            stripeSmsOveragePrice: amount,
          },
        },
      ).then(() => {
        this.snackbarMessage = 'Overage price updated.';
        this.updatingOverage = false;
        this.localEnterprise.owner.stripeSmsOveragePrice = amount;
      });
    },
  },
  computed: {
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },
  data: () => ({
    updatingOverage: false,
    creatingPrice: false,
    enterpriseService: new EnterpriseService(),
    overage: {
      newPrice: '',
      prices: [],
    },
    snackbarMessage: '',
  }),
  mounted() {
    this.overage.newPrice = this.enterprise.owner.stripeSmsOveragePrice / 100;
  },
};
</script>
